import { useCanRead } from '@artic/api-client';
import { useFeatureFlag } from '@artic/ui/feature-flags';
import { getQualityUrl } from '@artic/ui/lib/environment';
import { useTranslation } from 'react-i18next';

import type { LinkItemProps } from '~/layout/SidebarLayout';

/**
 * Settings → Imports, mirrored from Neo's `quality-sidebar.tsx` (ENG-1022): Work Order Imports
 * and Material Imports, both Neo pages, so both are absolute hrefs.
 *
 * Material Imports is disabled rather than hidden while `bill_of_materials` is off, as in Neo,
 * and hidden outright when `materials` is unreadable. Work Order Imports stays unflagged here,
 * as the Hub's Imports entry always has been.
 */
export function useImportsNavSubheader(): LinkItemProps {
  const { t } = useTranslation('translation');
  const billOfMaterials = useFeatureFlag('bill_of_materials');
  const canReadMaterials = useCanRead('materials');
  const quality = getQualityUrl();

  return {
    kind: 'subheader',
    name: t('nav.imports'),
    children: [
      { name: t('nav.work_order_imports'), href: `${quality}/imports` },
      {
        name: t('nav.material_imports'),
        href: `${quality}/material-imports`,
        disabled: !billOfMaterials,
        hide: !canReadMaterials,
      },
    ],
  };
}
